import React from 'react'
import data from './data'

const Table = () => {

  const headers = data.headers
  const rows = data.rows

  const buildColumns = index => {
    const rowData = Object.values(rows)[index]
    return (
      Object.values(rowData).map((value, index) => {
        if (typeof value === 'string') {
          return (
            <td key={index}>
              {value}<sup>% *</sup>
            </td>
          )
        } else {
          let color
          index === 2 ? color = 'blue' : color = 'gray'
          return (
            <td className="circle_cell" key={index}>
              {value === true && <div className={`liability-circle ${color}`}></div>}
            </td>
          )
        }
      })
    )
  }

  return (
    <table className="table insurance-liability-table" id="insurance_liability_table">
      <thead>
        <tr>
          <th></th>
          {headers.map((header, index) => (
            <th key={index}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Object.keys(rows).map((row, index) => {
          const className = index % 2 ? 'even' : 'odd'
          return (
            <tr className={className} key={index}>
              <td className="liability_name">
                {row}
              </td>
              {buildColumns(index)}
            </tr>
          )
        })}
      </tbody>
    </table>
  )
}

export default Table